module.exports = __webpack_public_path__ + "static/supportImg-86581c36a4eabc5bd96aed14fbc8e6c5.svg";